/**
 * Processamento immagini per upload
 *
 * Questo modulo orchestra la validazione e conversione delle immagini
 * prima dell'upload, gestendo automaticamente i formati non supportati.
 */

import { isHeicFile, verifyHeicMagicBytes } from './heic/detector';

/**
 * Processa un file immagine per l'upload.
 *
 * Se il file è in formato HEIC/HEIF, viene automaticamente convertito in JPEG.
 * Per altri formati, il file viene restituito invariato.
 *
 * Il convertitore HEIC (libheif-js + WASM, ~2MB) viene caricato dinamicamente
 * solo quando serve davvero, mantenendolo fuori dal bundle principale.
 *
 * @param file - Il file immagine da processare
 * @returns Il file originale o convertito in JPEG se era HEIC
 */
export async function processImageFile(file: File): Promise<File> {
  if (!isHeicFile(file)) {
    return file;
  }

  const isActuallyHeic = await verifyHeicMagicBytes(file);

  if (!isActuallyHeic) {
    logMislabeledHeicWarning(file.name);
    return file;
  }

  const { convertHeicToJpeg } = await import('./heic/converter');
  return convertHeicToJpeg(file);
}

function logMislabeledHeicWarning(fileName: string): void {
  console.warn(`File "${fileName}" has .heic extension but is not a real HEIC file`);
}
